import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useMemo } from 'react';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';

function AddCart_5({ item, isActive }) {
  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data;
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = useMemo(() => {
    return staticComponentValueConverter(item?.customization);
  }, [item]);

  const iconFilter = useMemo(() => HexToHueConverter(customization?.iconColor), [customization?.iconColor]);

  return (
    <>
      <div
        style={{
          bottom: 0,
          width: '100%',
          backgroundColor: 'white',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingLeft: staticValues[10],
          paddingRight: staticValues[10],
          paddingTop: staticValues[10],
          paddingBottom: staticValues[10],
          borderTopWidth: 1,
          borderTopColor: '#eee',
          shadowOffset: {
            width: 0,
            height: -2,
          },
          shadowOpacity: 0.1,
          shadowRadius: 4,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: 2,
          backgroundColor: customization?.backgroundColor,
          zIndex: 15,
        }}
      >
        <div
          style={{
            color: customization?.buttonTextColor,
            backgroundColor: customization?.buttonBackgroundColor,
            borderRadius: 8,
            paddingLeft: staticValues[8],
            paddingRight: staticValues[8],
            paddingTop: staticValues[8],
            paddingBottom: staticValues[8],
            width: '100%',
            fontSize: customization?.buttonTextSize,
            fontWeight: customization?.buttonTextWeight,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
          }}
        >
          {customization?.isIcon && (
            <div className="right-0">
              <img
                className="shrink-0"
                src={customization?.icon}
                alt=""
                style={{ filter: iconFilter, width: customization?.iconWidth }}
              />
            </div>
          )}
          {item?.data.buttonText}
        </div>
      </div>
    </>
  );
}

export default AddCart_5;
